import * as React from 'react';

const ChevronFirstChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} {...props}>
        <path d="M14.999 7l1.415 1.415L12.828 12l3.586 3.586L14.999 17 10 12l4.999-5zM9 7v10H7V7h2z" />
    </svg>
);

ChevronFirstChunkySvg.displayName = 'ChevronFirstChunkySvg';
export default ChevronFirstChunkySvg;
